import styled from "styled-components";
import {menuTextColor} from "../../style/styleConsts";
import Loader from "./Loader";
import React from "react";

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.disabled ? "#e2dede" : menuTextColor};
    color: ${props => props.disabled ? "#4a4a4a" : "#ffffff"};
    border-style: none;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    margin-top: 8px;
    margin-bottom: 8px;
    border-radius: 3px;
    width: 40%;
`;

const Content = styled.div`
    padding-top: 8px;
    padding-bottom: 8px;
`;

const ActionButton = ({children, onClick, disabled, isLoading, className}) => {
    const content = isLoading ? <Loader/> : children;

    return <Container className={className} disabled={disabled} onClick={onClick}>
        <Content>
            {content}
        </Content>
    </Container>;
};

export default ActionButton;